import { company as en_company } from "../en/company";

/** company — RU slice (183 keys). */
export const company: Record<keyof typeof en_company, string> = {
  company_intro_description:
    "Как площадка для мероприятий, Linqx поможет тебе собирать друзей и управлять своими событиями.",
  company_intro_sign_in_email: "Войти по email",
  company_intro_sign_in_code: "Войти по коду",
  company_intro_trouble: "Проблемы со входом?",
  company_title_header: "Название бизнеса",
  company_title_placeholder: "Добавь название события",
  company_title_hint:
    "Именно так это будет отображаться в Linqx, и изменить это уже нельзя.",
  company_ein_header: "EIN бизнеса",
  company_ein_hint: "Введи свой идентификационный номер работодателя (EIN).",
  company_admin_header: "Настройки администратора",
  company_admin_subtitle: "Я —",
  company_admin_owner: "Владелец",
  company_admin_admin: "Админ",
  company_admin_other: "Другое",
  company_contact_header: "Контактные данные",
  company_contact_email: "Email",
  company_contact_phone: "Телефон",
  company_type_header: "Тип бизнеса",
  company_type_hint: "Выбери всё, что подходит",
  company_welcome_rules_title: "Фото подчиняются этим правилам площадки:",
  company_welcome_rule_1_title: "Управляй событиями",
  company_welcome_rule_1_desc:
    "Просматривай, редактируй и управляй всеми событиями с телефона или в вебе.",
  company_welcome_rule_2_title: "Гости / бронирования",
  company_welcome_rule_2_desc:
    "Смотри полные списки приглашённых и подтвердивших участие в выбранном событии.",
  company_welcome_rule_3_title: "Подтверждение по QR",
  company_welcome_rule_3_desc:
    "Подтверждай свои бронирования прямо в приложении в цифровом виде.",
  company_welcome_rule_4_title: "Будь на шаг впереди",
  company_welcome_rule_4_desc: "Всегда сообщай о плохом поведении.",
  company_welcome_agree: "Согласен",
  company_complete_message: "Твой бизнес успешно зарегистрирован!",
  company_complete_start_tutorial: "Начать обучение",
  company_complete_skip: "Пропустить",
  company_dashboard_title: "Панель управления",
  company_dashboard_employees: "Сотрудники",
  company_dashboard_employees_count: "{count} участников команды",
  company_dashboard_add_employee: "Добавить сотрудника",
  company_dashboard_manage_team: "Управлять командой",
  company_dashboard_view_all: "Смотреть все",
  company_employees_title: "Участники команды",
  company_employees_empty: "Пока нет участников команды",
  company_employees_empty_hint:
    "Добавь сотрудников, чтобы помогать управлять бизнесом",
  company_employees_search: "Поиск сотрудников...",
  company_employees_add_first: "Добавь первого сотрудника",
  company_employee_title: "Данные сотрудника",
  company_employee_role: "Роль",
  company_employee_contact: "Контактная информация",
  company_employee_email: "Email",
  company_employee_phone: "Телефон",
  company_employee_status: "Статус",
  company_employee_update_role: "Изменить роль",
  company_employee_update_contact: "Изменить контакты",
  company_employee_remove: "Удалить сотрудника",
  company_employee_remove_confirm: "Точно хочешь удалить этого сотрудника?",
  company_add_employee_title: "Добавить участника команды",
  company_add_employee_user_id: "ID пользователя",
  company_add_employee_user_id_placeholder: "Введи ID пользователя",
  company_add_employee_email: "Адрес email",
  company_add_employee_email_placeholder: "Введи адрес email",
  company_add_employee_phone: "Номер телефона",
  company_add_employee_phone_placeholder: "Введи номер телефона",
  company_add_employee_role: "Выбери роль",
  company_add_employee_role_hint: "Выбери роль для этого участника команды",
  company_add_employee_success: "Сотрудник успешно добавлен",
  company_add_employee_button: "Добавить сотрудника",
  company_role_owner: "Владелец",
  company_role_admin: "Админ",
  company_role_moderator: "Модератор",
  company_role_staff: "Сотрудник",
  company_status_active: "Активен",
  company_status_inactive: "Неактивен",
  company_status_suspended: "Заблокирован",
  company_status_resigned: "Уволился",
  business_title: "Linqx для бизнеса",
  business_new_company: "Новая",
  business_no_companies: "Пока нет компаний",
  business_no_companies_description:
    "Создай свою первую компанию, чтобы начать управлять бизнесом в Linqx.",
  business_create_company: "Создать компанию",
  business_team: "Команда",
  business_add_member: "Добавить участника",
  business_no_team_members: "Нет участников команды",
  business_no_team_members_description:
    "Добавь участников команды, чтобы помогать управлять бизнесом.",
  business_members_count: "{count} участник(ов)",
  business_information: "Информация",
  business_team_management: "Управление командой",
  business_name: "Название",
  business_description: "Описание",
  business_basic: "ОСНОВНОЕ",
  business_members: "УЧАСТНИКИ",
  business_events_section: "СОБЫТИЯ",
  business_events: "События",
  business_status: "Статус",
  business_created: "Создано",
  business_draft: "Черновик",
  business_company_not_found: "Компания не найдена",
  business_business_name_label: "Название бизнеса",
  business_business_name_placeholder: "Введи название бизнеса",
  business_business_name_appears:
    "Именно так твой бизнес будет отображаться в Linqx.",
  business_ein_label: "EIN",
  business_ein_placeholder: "XX-XXXXXXX",
  business_ein_error_numeric:
    "EIN должен содержать только цифры (цифры и необязательный дефис).",
  business_ein_error_length:
    "EIN должен состоять ровно из 9 цифр (XX-XXXXXXX).",
  business_save_failed: "Не удалось сохранить. Попробуйте еще раз.",
  business_ein_verification_description:
    "Введи свой EIN для верификации бизнеса.",
  business_role_select_description: "Выбери свою роль в этом бизнесе.",
  business_contact_description: "Как клиенты могут связаться с твоим бизнесом?",
  business_email_label: "Email бизнеса",
  business_contact_email_invalid: "Пожалуйста, введите корректный email.",
  business_email_placeholder: "hello@yourbusiness.com",
  business_phone_label: "Номер телефона",
  business_phone_placeholder: "+1 (555) 000-0000",
  business_type_select_description:
    "Выбери категории, которые описывают твой бизнес.",
  business_welcome_review_description:
    "Пожалуйста, ознакомься и прими наши правила для бизнеса.",
  business_welcome_rule_1: "Держи информацию о бизнесе точной и актуальной",
  business_welcome_rule_2:
    "Относись ко всем участникам команды и клиентам с уважением",
  business_welcome_rule_3:
    "Соблюдай свои обязательства по событиям и продаже билетов",
  business_welcome_rule_4: "Всегда следуй правилам сообщества Linqx",
  business_accept_continue: "Принять и продолжить",
  business_accepting: "Принимаем...",
  business_complete_description:
    "Твой бизнес создан. Теперь ты можешь управлять командой и развиваться в Linqx.",
  business_creating: "Создаём...",
  business_verifying: "Проверяем...",
  business_saving: "Сохраняем...",
  business_sending: "Отправляем...",
  business_onboarding_name_title: "Назови свой бизнес",
  business_onboarding_ein_title: "Идентификационный номер работодателя",
  business_onboarding_skip_ein: "У меня нет EIN",
  business_onboarding_role_title: "Твоя роль",
  business_onboarding_contact_title: "Контактная информация",
  business_onboarding_type_title: "Тип бизнеса",
  business_onboarding_welcome_title: "Почти готово!",
  business_onboarding_complete_title: "Всё готово!",
  business_onboarding_step_of: "Шаг {current} из {total}",
  business_onboarding_selected_count: "Продолжить (выбрано {count})",
  business_role_owner: "Владелец",
  business_role_admin: "Админ",
  business_role_moderator: "Модератор",
  business_role_staff: "Сотрудник",
  business_role_owner_desc: "Полный контроль над бизнесом",
  business_role_admin_desc: "Может управлять командой и настройками компании",
  business_role_moderator_desc:
    "Может модерировать контент и работать с жалобами",
  business_role_staff_desc: "Базовый доступ участника команды",
  business_role_admin_onboarding_desc: "Управление командой и настройками",
  business_role_moderator_onboarding_desc: "Ограниченный доступ к управлению",
  business_search_members: "Поиск участников...",
  business_search_users: "Поиск пользователей...",
  business_pending: "Ожидает",
  business_invite_send: "Отправить приглашение",
  business_invite_add: "Добавить в команду",
  business_invite_pending_description:
    "Аккаунт с этим email не найден. Будет создано ожидающее приглашение — человек добавится автоматически, когда зарегистрируется.",
  business_invite_direct_description: "Будет добавлен сразу",
  business_dismiss: "Закрыть",
  business_edit_role: "Изменить роль",
  business_save: "Сохранить",
  business_continue: "Продолжить",
  business_go_to_dashboard: "Перейти на панель управления",
  business_add_role: "Добавить роль",
  business_edit: "Изменить",
  business_appoint_member: "Ты собираешься назначить {name} участником",
  business_current_role: "Текущая роль: {role}",
  business_email_address_label: "Адрес email",
  business_email_address_placeholder: "Введи адрес email...",
  business_already_member: "Этот человек уже участник этой компании.",
  business_existing_users: "Существующие пользователи",
  business_role_label: "Роль",
  business_business_type_label: "Тип бизнеса",
  business_business_name_input_placeholder: "Название бизнеса",
  business_business_description_placeholder:
    "Расскажи людям о своём бизнесе...",
  // LIN-145 — new vs existing business on the onboarding wizard
  business_checking: "Проверяем...",
  business_title_too_short:
    "Название бизнеса должно содержать не менее 2 символов.",
  business_title_already_member:
    "Вы уже состоите в этом бизнесе. Откройте его из списка ваших бизнесов.",
  business_title_not_joinable:
    "Бизнес с таким названием уже существует, но присоединиться к нему здесь нельзя. Попросите владельца пригласить вас.",
  business_title_exists_retry:
    "Бизнес с таким названием уже существует. Нажмите «Продолжить», чтобы присоединиться к нему.",
  business_too_many_attempts:
    "Слишком много попыток. Подождите несколько минут и попробуйте еще раз.",
  business_join_ein_title: "Присоединиться к «{title}»",
  business_join_ein_description:
    "«{title}» уже есть в Linqx. Введи его EIN, чтобы подтвердить, что ты из команды этого бизнеса.",
  business_join_ein_mismatch:
    "Этот EIN не совпадает с EIN бизнеса. Проверьте его и попробуйте еще раз.",
  business_join_already_member:
    "Вы уже участник этого бизнеса. Откройте его из списка ваших бизнесов.",
  business_join_failed: "Не удалось проверить EIN. Попробуйте еще раз.",
  business_role_new_org_note:
    "Это новая организация. Даже если ты не владелец, ты сможешь изменить это позже.",
  business_role_existing_org_note:
    "У «{title}» уже есть владелец. Выбери свою роль в команде.",
  business_type_set_by_owner: "Тип бизнеса задает владелец бизнеса.",
  business_type_none_set: "Владелец еще не указал тип бизнеса.",
  business_join_complete_description:
    "Теперь ты в команде «{title}». Открыть бизнес можно в любой момент из списка.",
};
